import Container from '@/views/container'
export default [
  {
    path: '/',
    component: () => import('@/views/index'),
    meta: {
      hideInMenu: true
    }
  },
	{
		path: '/home',
		component: Container,
		meta: {
			title: '首页',
			icon: 'el-icon-cloudy',
			index: '10'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/home')
			}
		]
	},
	{
		path: '/hr',
		component: Container,
		meta: {
			title: '人事管理',
			icon: 'el-icon-date',
			index: '12'
		},
		children: [
			{
				path: 'branch',
				component: () => import('@/views/hr/branch'),
				meta: {
					title: '部门',
					index: '12-10',
					verifyCode: 'branch'
				}
			},
			{
				path: 'staff',
				component: () => import('@/views/hr/staff'),
				meta: {
					title: '员工',
					index: '12-11',
					verifyCode: 'staff'
				}
			},
			{
				path: 'attendance',
				component: () => import('@/views/hr/attendance'),
				meta: {
					title: '考勤',
					index: '12-12',
					verifyCode: 'attendance'
				}
			},
			{
				path: 'salary',
				component: () => import('@/views/hr/salary'),
				meta: {
					title: '薪资',
					index: '12-13',
					verifyCode: 'finance-salary'
				}
			},
			{
				path: 'perk',
				component: () => import('@/views/hr/perk'),
				meta: {
					title: '补助',
					index: '12-14',
					verifyCode: 'finance-perk'
				}
			},
			{
				path: 'insurance-plan',
				component: () => import('@/views/hr/insurance-plan'),
				meta: {
					title: '社保方案',
					index: '12-15',
					verifyCode: 'insurance-plan'
				}
			},
			{
				path: 'salary-plan',
				component: () => import('@/views/hr/salary-plan'),
				meta: {
					title: '薪资方案',
					index: '12-16',
					verifyCode: 'salary-plan'
				}
			}
		]
	},
	{
		path: '/customer',
		component: Container,
		meta: {
			title: '客户管理',
			icon: 'el-icon-user',
			index: '13'
		},
		children: [
			{
				path: 'audit-index',
				component: () => import('@/views/customer/audit-index'),
				meta: {
					title: '新客户审批',
					index: '13-11',
					verifyCode: 'customer-audit'
				}
			},
			{
				path: '',
				component: () => import('@/views/customer'),
				meta: {
					title: '客户',
					index: '13-10',
					verifyCode: 'customer'
				}
			},
			{
				path: 'channel',
				component: () => import('@/views/customer/channel'),
				meta: {
					title: '渠道',
					index: '13-12',
					verifyCode: 'customer-channel'
				}
			},
			{
				path: 'sop',
				component: () => import('@/views/customer/sop'),
				meta: {
					title: 'SOP',
					index: '13-13',
					verifyCode: 'customer-sop'
				}
			},
			{
				path: 'tag',
				component: () => import('@/views/customer/tag'),
				meta: {
					title: '标签',
					index: '13-14',
					verifyCode: 'customer-tag'
				}
			}
		]
	},

	{
		path: '/bom',
		component: Container,
		meta: {
			title: '物料管理',
			icon: 'el-icon-goods',
			index: '11'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/bom'),
				meta: {
					title: 'BOM',
					index: '11-10',
					verifyCode: 'bom'
				}
			},
			{
				path: 'log',
				component: () => import('@/views/bom/log'),
				meta: {
					title: 'BOM日志',
					index: '11-14',
					verifyCode: 'bom-log'
				}
			},
			{
				path: 'cate',
				component: () => import('@/views/bom/cate'),
				meta: {
					title: '分类',
					index: '11-12',
					verifyCode: 'bom-cate'
				}
			},
			{
				path: 'brand',
				component: () => import('@/views/bom/brand'),
				meta: {
					title: '品牌',
					index: '11-13',
					verifyCode: 'bom-brand'
				}
			}
		]
	},

	{
		path: '/stock',
		component: Container,
		meta: {
			title: '库存管理',
			icon: 'el-icon-school',
			index: '18'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/stock'),
				meta: {
					title: '库存明细',
					index: '18-10',
					verifyCode: 'stock'
				}
			},
			{
				path: 'bill-bom',
				component: () => import('@/views/stock/bill-bom'),
				meta: {
					title: '出入库明细',
					index: '18-11',
					verifyCode: 'stock-bill-bom'
				}
			},
			{
				path: 'in',
				component: () => import('@/views/stock/bill/in'),
				meta: {
					title: '入库',
					index: '18-12',
					verifyCode: 'stock-bill-in'
				}
			},
			{
				path: 'out',
				component: () => import('@/views/stock/bill/out'),
				meta: {
					title: '出库',
					index: '18-13',
					verifyCode: 'stock-bill-out'
				}
			},
			{
				path: 'scrap',
				component: () => import('@/views/stock/bill/scrap'),
				meta: {
					title: '报废',
					index: '18-14',
					verifyCode: 'stock-bill-scrap'
				}
			},
			{
				path: 'check',
				component: () => import('@/views/stock/check'),
				meta: {
					title: '盘点',
					index: '18-15',
					verifyCode: 'stock-check'
				}
			},
			{
				path: 'store',
				component: () => import('@/views/stock/store'),
				meta: {
					title: '仓库',
					index: '18-16',
					verifyCode: 'stock-store'
				}
			}
		]
	},
	// {
	// 	path: '/order',
	// 	component: Container,
	// 	meta: {
	// 		title: '销售管理',
	// 		icon: 'el-icon-price-tag',
	// 		index: '16'
	// 	},
	// 	children: [
	// 		{
	// 			path: '',
	// 			component: () => import('@/views/order'),
	// 			meta: {
	// 				title: '销售订单',
	// 				index: '16-10',
	// 				verifyCode: 'order'
	// 			}
	// 		},
	// 		{
	// 			path: 'express',
	// 			component: () => import('@/views/order/express'),
	// 			meta: {
	// 				title: '运输物流',
	// 				index: '16-18',
	// 				verifyCode: 'order-express'
	// 			}
	// 		},
	// 		{
	// 			path: 'debug',
	// 			component: () => import('@/views/order/debug'),
	// 			meta: {
	// 				title: '售后调试',
	// 				index: '16-13',
	// 				verifyCode: 'order-debug'
	// 			}			
	// 		},
	// 		{
	// 			path: 'contract-template',
	// 			component: () => import('@/views/order/contract-template'),
	// 			meta: {
	// 				title: '销售合同模板',
	// 				index: '16-16',
	// 				verifyCode: 'order-contract-template'
	// 			}
	// 		},
	// 		{
	// 			path: 'commission-plan',
	// 			component: () => import('@/views/order/commission-plan'),
	// 			meta: {
	// 				title: '提成方案',
	// 				index: '16-15',
	// 				verifyCode: 'order-commission-plan'
	// 			}
	// 		},
	// 		{
	// 			path: 'refund',
	// 			component: () => import('@/views/order/refund'),
	// 			meta: {
	// 				title: '销售退货',
	// 				index: '16-14',
	// 				verifyCode: 'order-refund'
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/made',
	// 	component: Container,
	// 	meta: {
	// 		title: '设计生产',
	// 		icon: 'el-icon-edit',
	// 		index: '25'
	// 	},
	// 	children: [
	// 		{
	// 			path: 'design',
	// 			component: () => import('@/views/order/design'),
	// 			meta: {
	// 				title: '图纸设计',
	// 				index: '25-12',
	// 				verifyCode: 'order-design'
	// 			}
	// 		},
	// 		{
	// 			path: 'produce',
	// 			component: () => import('@/views/order/produce'),
	// 			meta: {
	// 				title: '生产加工',
	// 				index: '25-17',
	// 				verifyCode: 'order-produce'
	// 			}
	// 		}
	// 	]
	// },
	{
		path: '/purchase',
		component: Container,
		meta: {
			title: '采购管理',
			icon: 'el-icon-truck',
			index: '15'
		},
		children: [
			{
				path: '',
				component: () => import('@/views/purchase'),
				meta: {
					title: '采购单',
					index: '15-10',
					verifyCode: 'purchase'
				}
			},
			{
				path: 'demand',
				component: () => import('@/views/purchase/demand'),
				meta: {
					title: '采购需求',
					index: '15-12',
					verifyCode: 'purchase-demand'
				}
			},
			{
				path: 'allot',
				component: () => import('@/views/purchase/allot'),
				meta: {
					title: '我要采购',
					index: '15-11',
					verifyCode: 'purchase'
				}
			},
			{
				path: 'supplier',
				component: () => import('@/views/purchase/supplier'),
				meta: {
					title: '供应商',
					index: '15-13',
					verifyCode: 'purchase-supplier'
				}
			},
			{
				path: 'quote',
				component: () => import('@/views/purchase/quote'),
				meta: {
					title: '报价',
					index: '15-15',
					verifyCode: 'purchase-quote'
				}
			},
			{
				path: 'contract-template',
				component: () => import('@/views/purchase/contract-template'),
				meta: {
					title: '采购合同模板',
					index: '15-16',
					verifyCode: 'purchase-contract-template'
				}
			},
			{
				path: 'refund',
				component: () => import('@/views/purchase/refund'),
				meta: {
					title: '采购退货',
					index: '15-17',
					verifyCode: 'purchase-refund'
				}
			}
		]
	},
	// {
	// 	path: '/project',
	// 	component: Container,
	// 	meta: {
	// 		title: '项目管理',
	// 		icon: 'el-icon-printer',
	// 		index: '17'
	// 	},
	// 	children: [
	// 		{
	// 			path: '',
	// 			component: () => import('@/views/project'),
	// 			meta: {
	// 				title: '项目',
	// 				index: '17-10',
	// 				verifyCode: 'project'
	// 			}
	// 		},
	// 		{
	// 			path: 'task',
	// 			component: () => import('@/views/project/task'),
	// 			meta: {
	// 				title: '任务管理',
	// 				index: '17-11',
	// 				verifyCode: 'project-task'
	// 			}				
	// 		},
	// 		{
	// 			path: 'member-task',
	// 			component: () => import('@/views/project/task/of-member-index'),
	// 			meta: {
	// 				title: '我的任务',
	// 				index: '17-12',
	// 				verifyCode: 'project-task-of-member'
	// 			}
	// 		},
	// 		{
	// 			path: 'report-stat',
	// 			component: () => import('@/views/project/report/stat'),
	// 			meta: {
	// 				title: '工时统计',
	// 				index: '17-13',
	// 				verifyCode: 'project-work-hour'
	// 			}					
	// 		},
	// 		{
	// 			path: 'member-remain',
	// 			component: () => import('@/views/project/member/remain'),
	// 			meta: {
	// 				title: '剩余工时',
	// 				index: '17-15',
	// 				verifyCode: 'project-remain-work-hour'
	// 			}
	// 		},
	// 		{
	// 			path: 'task-norm',
	// 			component: () => import('@/views/project/task-norm'),
	// 			meta: {
	// 				title: '标准工时',
	// 				index: '17-16',
	// 				verifyCode: 'project-task-norm'
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/finance',
	// 	component: Container,
	// 	meta: {
	// 		title: '财务管理',
	// 		icon: 'el-icon-money',
	// 		index: '19'
	// 	},
	// 	children: [
	// 		{
	// 			path: 'bill',
	// 			component: () => import('@/views/finance/bill'),
	// 			meta: {
	// 				title: '报账',
	// 				index: '19-10',
	// 				verifyCode: 'finance-bill'
	// 			}
	// 		},
	// 		{
	// 			path: 'bill-finished',
	// 			component: () => import('@/views/finance/bill/index-finished'),
	// 			meta: {
	// 				title: '入账账单',
	// 				index: '19-11',
	// 				verifyCode: 'finance-bill-finished'
	// 			}				
	// 		},
	// 		{
	// 			path: 'trade',
	// 			component: () => import('@/views/finance/trade'),
	// 			meta: {
	// 				title: '收/付款',
	// 				index: '19-12',
	// 				verifyCode: 'finance-trade'
	// 			}
	// 		},
	// 		{
	// 			path: 'invoice',
	// 			component: () => import('@/views/finance/invoice'),
	// 			meta: {
	// 				title: '发票',
	// 				index: '19-28',
	// 				verifyCode: 'finance-invoice'
	// 			}
	// 		},
	// 		{
	// 			path: 'project',
	// 			component: () => import('@/views/finance/project'),
	// 			meta: {
	// 				title: '项目',
	// 				index: '19-15',
	// 				verifyCode: 'finace-project'
	// 			}
	// 		},
	// 		{
	// 			path: 'com-bankcard',
	// 			component: () => import('@/views/finance/com-bankcard'),
	// 			meta: {
	// 				title: '公司账户',
	// 				index: '19-16',
	// 				verifyCode: 'finance-com-bankcard'
	// 			}
	// 		},
	// 		{
	// 			path: 'person-bankcard',
	// 			component: () => import('@/views/finance/person-bankcard'),
	// 			meta: {
	// 				title: '个人收款账户',
	// 				index: '19-17',
	// 				verifyCode: 'finance-person-bankcard'
	// 			}
	// 		},
	// 		{
	// 			path: 'cate',
	// 			component: () => import('@/views/finance/cate'),
	// 			meta: {
	// 				title: '业务分类',
	// 				index: '19-18',
	// 				verifyCode: 'finance-cate'
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/bi',
	// 	component: Container,
	// 	meta: {
	// 		title: '商业智能',
	// 		icon: 'el-icon-data-line',
	// 		index: '20'
	// 	},
	// 	children: [
	// 		{
	// 			path: 'customer-count',
	// 			component: () => import('@/views/bi/customer-count'),
	// 			meta: {
	// 				title: '客户总量分析',
	// 				index: '20-10',
	// 				verifyCode: 'bi-customer-count'
	// 			}
	// 		},
	// 		{
	// 			path: 'customer-service',
	// 			component: () => import('@/views/bi/customer-service'),
	// 			meta: {
	// 				title: '客户跟进分析',
	// 				index: '20-11',
	// 				verifyCode: 'bi-customer-service'
	// 			}				
	// 		},
	// 		{
	// 			path: 'customer-transform',
	// 			component: () => import('@/views/bi/customer-transform'),
	// 			meta: {
	// 				title: '客户转化分析',
	// 				index: '20-12',
	// 				verifyCode: 'bi-customer-transform'
	// 			}					
	// 		},
	// 		{
	// 			path: 'customer-city',
	// 			component: () => import('@/views/bi/customer-city'),
	// 			meta: {
	// 				title: '客户城市分析',
	// 				index: '20-13',
	// 				verifyCode: 'bi-customer-city'
	// 			}					
	// 		},
	// 		{
	// 			path: 'customer-tag',
	// 			component: () => import('@/views/bi/customer-tag'),
	// 			meta: {
	// 				title: '客户标签分析',
	// 				index: '20-14',
	// 				verifyCode: 'bi-customer-tag'
	// 			}					
	// 		},
	// 		{
	// 			path: 'customer-channel',
	// 			component: () => import('@/views/bi/customer-channel'),
	// 			meta: {
	// 				title: '客户渠道分析',
	// 				index: '20-15',
	// 				verifyCode: 'bi-customer-channel'
	// 			}					
	// 		},
	// 		{
	// 			path: 'order-count',
	// 			component: () => import('@/views/bi/order-count'),
	// 			meta: {
	// 				title: '订单数量分析',
	// 				index: '20-16',
	// 				verifyCode: 'bi-order-count'
	// 			}	
	// 		},
	// 		{
	// 			path: 'order-amount',
	// 			component: () => import('@/views/bi/order-amount'),
	// 			meta: {
	// 				title: '订单金额分析',
	// 				index: '20-17',
	// 				verifyCode: 'bi-order-amount'
	// 			}					
	// 		},
	// 		{
	// 			path: 'order-payment',
	// 			component: () => import('@/views/bi/order-payment'),
	// 			meta: {
	// 				title: '订单回款分析',
	// 				index: '20-18',
	// 				verifyCode: 'bi-order-payment'
	// 			}					
	// 		},
	// 		{
	// 			path: 'bom-sale',
	// 			component: () => import('@/views/bi/bom-sale'),
	// 			meta: {
	// 				title: '产品销量统计',
	// 				index: '20-19',
	// 				verifyCode: 'bi-bom-sale'
	// 			}					
	// 		},
	// 		{
	// 			path: 'bom-cate-sale',
	// 			component: () => import('@/views/bi/bom-cate-sale'),
	// 			meta: {
	// 				title: '产品分类销量',
	// 				index: '20-20',
	// 				verifyCode: 'bi-bom-cate-sale'
	// 			}					
	// 		}
	// 	]
	// },
	{
		path: '/setting',
		component: Container,
		meta: {
			title: '设置',
			icon: 'el-icon-setting',
			index: '99',
		},
		children: [
			{
				path: 'api',
				component: () => import('@/views/setting/api'),
				meta: {
					title: 'API',
					index: '99-10',
					verifyCode: 'api'
				}
			},
			{
				path: 'role',
				component: () => import('@/views/setting/role'),
				meta: {
					title: '角色',
					index: '99-11',
					verifyCode: 'role'
				}
			},
			{
				path: 'audit',
				component: () => import('@/views/setting/audit'),
				meta: {
					title: '审批流程',
					index: '99-12',
					verifyCode: 'audit'
				}
			},
			{
				path: 'com',
				component: () => import('@/views/setting/com'),
				meta: {
					title: '公司主体',
					index: '99-13',
					verifyCode: 'com'
				}
			}
		]
	}

]